/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ScienceIcon = /*#__PURE__*/ createSvgIcon(
  'ScienceIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.5 17c-.639 0-1.097-.281-1.375-.844-.278-.562-.215-1.088.187-1.577L7.5 9.5v-5h-.745a.736.736 0 01-.536-.214A.714.714 0 016 3.754c0-.21.072-.39.216-.535A.72.72 0 016.75 3h6.5c.213 0 .39.071.535.214a.72.72 0 01.215.532c0 .21-.072.39-.215.535a.72.72 0 01-.535.219h-.75v5l4.188 5.083c.389.486.444 1.01.166 1.573-.277.563-.729.844-1.354.844h-11zm0-1.5h11L11 10V4.5H9V10l-4.5 5.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ScienceIcon;
